import { render, staticRenderFns } from "./healthcareView.vue?vue&type=template&id=47b3d36e&scoped=true"
import script from "./healthcareView.vue?vue&type=script&lang=js"
export * from "./healthcareView.vue?vue&type=script&lang=js"
import style0 from "./healthcareView.vue?vue&type=style&index=0&id=47b3d36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b3d36e",
  null
  
)

export default component.exports